type PropTypes = {
  className?: string
}

const ListViewIcon = ({ className }: PropTypes) => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M21 4.5H7.5V6H21V4.5Z" fill="currentColor" />
      <path d="M21 18H7.5V19.5H21V18Z" fill="currentColor" />
      <path d="M21 11.25H7.5V12.75H21V11.25Z" fill="currentColor" />
      <path d="M4.5 11.25H3V12.75H4.5V11.25Z" fill="currentColor" />
      <path d="M4.5 4.5H3V6H4.5V4.5Z" fill="currentColor" />
      <path d="M4.5 18H3V19.5H4.5V18Z" fill="currentColor" />
    </svg>
  )
}

export default ListViewIcon
